import React from 'react';
import { Handle, Position } from 'reactflow';
import useSyncNodeInternals from '../Components/useSyncNodeInternals';

import { FaBrain } from 'react-icons/fa';
import NodeCardShell from '../Components/NodeCardShell';

const ASSISTANT_NODE_COLOR = '#A7ADA7';

const AssitantAI = ({ data, isConnectable, id, selected }) => {
  useSyncNodeInternals(id, `${data.saved}~${data.first}`);

  return (
    <NodeCardShell
      icon={FaBrain}
      color={ASSISTANT_NODE_COLOR}
      typeName="Asistente IA"
      title={data.title ?? 'Asistente IA'}
      summary={data.assistant?.name}
      trigger={data.user_response}
      error={data?.error}
      selected={selected}
      first={data.first}
      handles={
        <>
          {!data.first && data.saved && (
            <Handle
              type="target"
              position={Position.Top}
              isConnectable={isConnectable}
              id={`target-${id}`}
              style={{ backgroundColor: ASSISTANT_NODE_COLOR }}
            />
          )}
          {data.saved && (
            <Handle
              type="source"
              position={Position.Bottom}
              id={`source-${id}`}
              isConnectable={isConnectable}
              style={{ backgroundColor: ASSISTANT_NODE_COLOR }}
            />
          )}
        </>
      }
    />
  );
};

export default React.memo(AssitantAI);
